import dayjs from 'dayjs';

/**
 * Print date/time.
 * @param inputDate The datetime as a string in UTC.
 * @param {string} preset - output format
 * @param {string} timezone - use timezone like 'US/Eastern' to display date.
 * @return the formatted date (and time) as a string.
 */
export default function dateTimeFormat(
  inputDate,
  timezone,
  preset = 'dateAndTimeShort',
) {
  const presets = {
    date: 'M/D/YYYY',
    dateAndTime: 'M/D/YYYY h:mm A',
    dateAndTimeZoned: 'M/D/YYYY h:mm A z',
    dateAndTimeZonedTwoLines: 'M/D/YYYY[\n]h:mm A z',
    time: 'h:mm A z',
    dateAndTimeShort: 'MM/DD[\n]hh:mm A',
    dateLong: 'MMMM D, YYYY',
    dateTimeFile: 'YYYYMMDD-hhmmss',
    dateShort: 'M/DD/YY',
    dateStandard: 'MM/DD/YYYY',
    dateShortMonth: 'MMM D, YYYY',
    dateDatabaseFormat: 'YYYY-MM-DD',
  };
  if (inputDate === null) {
    return '';
  }
  let dt = dayjs(inputDate);
  if (timezone) {
    dt = dt.tz(timezone);
  } else {
    dt = dt.utc().local();
  }

  return dt.format(presets[preset]);
}
